import { utf16Length } from "./string-validation"
import { z } from "zod"

export const GEN_HEALTH_REDIRECT_URL_MAX_LENGTH = 2_048

const absoluteHttpUrlSchema = z
	.string()
	.trim()
	.refine((value) => {
		try {
			const url = new URL(value)
			return url.protocol === "http:" || url.protocol === "https:"
		} catch {
			return false
		}
	}, "URL must be an absolute http:// or https:// address")

export const GenHealthPostVisitRedirectSettingsSchema = z
	.object({
		postVisitRedirectEnabled: z.boolean(),
		postVisitRedirectUrl: z.string().nullable(),
		recommendedRedirectUrl: z.string(),
	})
	.meta({ id: "GenHealthPostVisitRedirectSettings" })

export type GenHealthPostVisitRedirectSettings = z.infer<typeof GenHealthPostVisitRedirectSettingsSchema>

export const UpdateGenHealthPostVisitRedirectSchema = z
	.object({
		postVisitRedirectEnabled: z.boolean(),
		postVisitRedirectUrl: z.string().trim().apply(utf16Length("max", GEN_HEALTH_REDIRECT_URL_MAX_LENGTH)).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.postVisitRedirectUrl === undefined || value.postVisitRedirectUrl.length === 0) {
			if (value.postVisitRedirectEnabled) {
				ctx.addIssue({
					code: "custom",
					path: ["postVisitRedirectUrl"],
					message: "Redirect URL is required when post-visit redirect is enabled",
				})
			}
			return
		}

		const parsed = absoluteHttpUrlSchema.safeParse(value.postVisitRedirectUrl)
		if (!parsed.success) {
			ctx.addIssue({
				code: "custom",
				path: ["postVisitRedirectUrl"],
				message: parsed.error.issues[0]?.message ?? "Invalid redirect URL",
			})
		}
	})
	.meta({ id: "UpdateGenHealthPostVisitRedirect" })

export type UpdateGenHealthPostVisitRedirect = z.infer<typeof UpdateGenHealthPostVisitRedirectSchema>
